import React from "react";
import { CommonConfirmationDialog } from "../DialogComponent/SupplyDataDialog";

const ENTERPRISE_SALES_EMAIL = "support@proteams.io";

const TrialExpiryRecommendationModal = ({ open, onClose, recommendation, onViewPlans }) => {
  const isEnterprise = recommendation?.isEnterprise;
  const planLabel = recommendation?.label || "the right plan";

  if (isEnterprise) {
    return (
      <CommonConfirmationDialog
        open={open}
        onClose={onClose}
        title="Your trial has ended"
        message={
          <>
            Your configuration exceeds our self-serve plans. Contact Enterprise Sales for a
            custom plan, or reduce active users to fit within Launch, Growth, or Scale.
            Deactivated users do not count toward seat totals.
          </>
        }
        buttonTitle="Contact Enterprise Sales"
        onConfirm={() => {
          window.location.href = `mailto:${ENTERPRISE_SALES_EMAIL}?subject=Enterprise%20Plan%20Inquiry`;
          onClose?.();
        }}
      />
    );
  }

  return (
    <CommonConfirmationDialog
      open={open}
      onClose={onClose}
      title="Your trial has ended"
      message={
        <>
          Based on your configuration ({recommendation?.activeBackOffice || 0} back office,{" "}
          {recommendation?.activeField || 0} field), we recommend <strong>{planLabel}</strong>.
          Choose a plan to restore full access.
        </>
      }
      buttonTitle="View Plans"
      onConfirm={() => {
        onViewPlans?.();
        onClose?.();
      }}
    />
  );
};

export const shouldShowTrialExpiryRecommendation = (userProfile) => {
  if (!userProfile?.subscriptionDataLoaded) return false;
  const status = String(userProfile?.subscriptionDetails?.status || "").toLowerCase();
  const isTrial = status === "trialing" || status === "trial";
  if (!isTrial) return false;

  const trialEnd = Number(userProfile?.subscriptionDetails?.current_period_end);
  if (!Number.isFinite(trialEnd)) return false;
  if (Date.now() / 1000 <= trialEnd) return false;

  try {
    return sessionStorage.getItem("trialExpiryRecommendationShown") !== "1";
  } catch (_error) {
    return false;
  }
};

export const markTrialExpiryRecommendationShown = () => {
  try {
    sessionStorage.setItem("trialExpiryRecommendationShown", "1");
  } catch (_error) {
    /* ignore */
  }
};

export default TrialExpiryRecommendationModal;
